import type { SVGProps } from 'react';
import { useId } from 'react';

export interface FormularyIconProps extends Omit<SVGProps<SVGSVGElement>, 'xmlns' | 'children'> {}

const FormularyIcon = ({
  className,
  width = '20',
  height = '20',
  ...rest
}: FormularyIconProps) => {
  const clipPathId = useId().replace(/:/g, '');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      {...rest}
      width={width}
      height={height}
      className={className}
      fill="none"
      aria-hidden={true}
      focusable="false"
    >
      <defs>
        <clipPath id={clipPathId}>
          <rect width="10" height="10" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
      <rect width="20" height="20" rx="10" fill="#94C947" />
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M14.7676 6.63439C14.4582 6.32457 13.9558 6.32477 13.646 6.63439L8.59787 11.6827L6.35419 9.43906C6.04438 9.12924 5.54217 9.12924 5.23236 9.43906C4.92255 9.74887 4.92255 10.2511 5.23236 10.5609L8.03684 13.3654C8.19165 13.5202 8.39464 13.5978 8.59765 13.5978C8.80067 13.5978 9.00386 13.5204 9.15867 13.3654L14.7676 7.7562C15.0775 7.4466 15.0775 6.94418 14.7676 6.63439Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default FormularyIcon;
